// DO NOT USE THIS GOING FORWARD. INSTEAD:
// import { EverlaneLink } from 'base/components/router_link'
// https://github.com/Everlane/foundationjs/tree/master/packages/link

import React from 'react'
import classNames from 'classnames'
import routeTo from 'base/lib/route_to'
import { Chevron } from '@everlane/icon'
import RouterLink from 'base/components/router_link'

export default function Link({
  onClick,
  href = '',
  className = '',
  rightArrow = false,
  grey = false,
  inheritColor = false,
  children = '',
  color = '#a3a5a7',
  style = { cursor: 'pointer' },
}) {
  const handleClick = event => {
    event.preventDefault()
    if (onClick) {
      onClick(event)
    } else if (href) {
      routeTo(href)
    }
  }

  return (
    <RouterLink
      to={href}
      onClick={handleClick}
      style={{ ...style }}
      className={classNames(
        'tw-inline-flex tw-items-center tw-text-base',
        {
          'tw-text-brand-medium-grey hover:tw-text-brand-dark-grey': !inheritColor && grey,
          'tw-text-brand-navy hover:tw-text-brand-dark-navy': !inheritColor && !grey,
        },
        className,
      )}
    >
      {children}
      {rightArrow && (
        <Chevron width="12" height="12" data-rotate="90" style={{ color, marginLeft: '4px' }} />
      )}
    </RouterLink>
  )
}
